import { LayoutSetup, StepItemsList } from "@/components/setup/layout-setup";
import { useTranslation } from "@/hooks/useTranslation";
import { SetupTrialEndedBillingIntroductionPage } from "./trial-ended-billing/0-introduction";
import { SetupTrialEndedBillingPaymentMethodPage } from "./trial-ended-billing/1-payment-method";
import { SetupTrialEndedBillingFinishPage } from "./trial-ended-billing/2-finish";

export const SetupTrialEndedBilling = () => {
  const { t } = useTranslation();

  const steps: StepItemsList = [
    {
      id: "introduction",
      label: t("setup.trialEndedBilling.steps.introduction"),
      element: <SetupTrialEndedBillingIntroductionPage />,
    },
    {
      id: "payment-method",
      label: t("setup.trialEndedBilling.steps.paymentMethod"),
      element: <SetupTrialEndedBillingPaymentMethodPage />,
    },
    {
      id: "finish",
      label: t("setup.trialEndedBilling.steps.finish"),
      element: <SetupTrialEndedBillingFinishPage />,
    },
  ];

  return <LayoutSetup steps={steps} />;
};
